"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var shouldSpeakIncomingActivity = _ref.shouldSpeakIncomingActivity;
  return shouldSpeakIncomingActivity;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvc2hvdWxkU3BlYWtJbmNvbWluZ0FjdGl2aXR5LmpzIl0sIm5hbWVzIjpbInNob3VsZFNwZWFrSW5jb21pbmdBY3Rpdml0eSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUFlO0FBQUEsTUFBR0EsMkJBQUgsUUFBR0EsMkJBQUg7QUFBQSxTQUFxQ0EsMkJBQXJDO0FBQUEsQyIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0ICh7IHNob3VsZFNwZWFrSW5jb21pbmdBY3Rpdml0eSB9KSA9PiBzaG91bGRTcGVha0luY29taW5nQWN0aXZpdHk7XG4iXX0=